import { TableCell } from "@tiptap/extension-table-cell"

export const CustomTableCell = TableCell.extend({
  addAttributes() {
    return {
      ...this.parent?.(),
      rowType: {
        default: null,
        parseHTML: (element) => element.getAttribute("data-row-type") || null,
        renderHTML: (attributes) => {
          if (!attributes.rowType) return {}
          return { "data-row-type": attributes.rowType }
        },
      },
    }
  },
})
